export default __webpack_public_path__ + "static/5-62117542d788b25a7204ae769ddfcf8e.jpg";